<mat-accordion multi>
  <div class="qsa-tree__total" [class.qsa-tree__total--complete]="host.isLevelComplete(nodes)">
    Percentual total: {{ host.getTotalParticipation(nodes) }}
  </div>

  <ng-container *ngFor="let node of nodes; trackBy: trackByDocument">
    <div class="qsa-tree__node-header">
      <h4 class="fd-subtitle qsa-tree__title">
        {{ host.getNodeTitle(node) }}
        <fa-icon class="qsa-tree__check" icon="check" *ngIf="host.isNodeComplete(node)"></fa-icon>
      </h4>

      <button type="button" class="qsa-tree__remove" *ngIf="host.canRemoveNode(node)" (click)="host.removeNode(node)">
        <fa-icon icon="times"></fa-icon>
        excluir sócio
      </button>
    </div>

    <mat-expansion-panel #panel class="qsa-tree__panel" [class.qsa-tree__panel--complete]="host.isNodeComplete(node)" hideToggle>
      <mat-expansion-panel-header class="qsa-tree__header" collapsedHeight="auto" expandedHeight="auto">
        <!-- O stopPropagation mantem o abrir/fechar restrito ao botao de toggle. -->
        <div class="qsa-tree__header-content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <div class="qsa-tree__header-rows">
            <ng-container *ngTemplateOutlet="nodeRow; context: { node: node }"></ng-container>
            <ng-container *ngIf="node.legalRepresentative">
              <ng-container *ngTemplateOutlet="nodeRow; context: { node: node.legalRepresentative }"></ng-container>
            </ng-container>
          </div>

          <button
            type="button"
            class="qsa-tree__toggle"
            *ngIf="node.children.length"
            [class.qsa-tree__toggle--open]="panel.expanded"
            [attr.aria-expanded]="panel.expanded"
            [attr.aria-label]="panel.expanded ? 'Recolher sócios' : 'Expandir sócios'"
            (click)="panel.toggle()"
          >
            <fa-icon class="qsa-tree__toggle-icon" icon="chevron-down"></fa-icon>
          </button>
        </div>
      </mat-expansion-panel-header>

      <div class="qsa-tree__children" *ngIf="node.children.length">
        <app-qsa-node [nodes]="node.children" [host]="host"></app-qsa-node>
      </div>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>

<ng-template #nodeRow let-node="node">
  <div class="qsa-tree__row">
    <span class="qsa-tree__tag" *ngIf="node.isLegalRepresentative">Representante Legal</span>

    <div class="qsa-tree__row-main">
      <div class="qsa-tree__name">
        <div class="qsa-field qsa-field--text qsa-field--document">
          <span class="qsa-field__label">{{ node.documentType }}</span>
          <div class="qsa-field__content">
            <span class="qsa-field__value">{{ node.document | cpfCnpj }}</span>
          </div>
        </div>

        <div class="qsa-field qsa-field--text">
          <span class="qsa-field__label">{{ node.documentType === 'CNPJ' ? 'Razão social' : 'Nome' }}</span>
          <div class="qsa-field__content">
            <span class="qsa-field__value qsa-tree__person-name" [title]="node.name">{{ node.name }}</span>
          </div>
        </div>
      </div>

      <div class="qsa-tree__fields">
        <ng-container *ngIf="node.documentType === 'CPF'">
          <ng-container *ngIf="host.isCollapsed(node, 'birthDate'); else birthDateEdit">
            <ng-container *ngTemplateOutlet="fieldText; context: { node: node, field: 'birthDate' }"></ng-container>
          </ng-container>
          <ng-template #birthDateEdit>
            <div class="qsa-field" (focusout)="host.confirmField(node, 'birthDate', $event)">
              <fd-input [parentForm]="host.qsaFormsControls[node.formIndex]" [field]="host.fieldsArray[node.formIndex].birthDate">
              </fd-input>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="node.documentType === 'CNPJ'">
          <ng-container *ngIf="host.isCollapsed(node, 'openDate'); else openDateEdit">
            <ng-container *ngTemplateOutlet="fieldText; context: { node: node, field: 'openDate' }"></ng-container>
          </ng-container>
          <ng-template #openDateEdit>
            <div class="qsa-field" (focusout)="host.confirmField(node, 'openDate', $event)">
              <fd-input [parentForm]="host.qsaFormsControls[node.formIndex]" [field]="host.fieldsArray[node.formIndex].openDate">
              </fd-input>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="node.documentType === 'CPF'">
          <ng-container *ngIf="host.isCollapsed(node, 'nationality'); else nationalityEdit">
            <ng-container *ngTemplateOutlet="fieldText; context: { node: node, field: 'nationality' }"></ng-container>
          </ng-container>
          <ng-template #nationalityEdit>
            <div class="qsa-field qsa-field--nationality" (focusout)="host.confirmField(node, 'nationality', $event)">
              <fd-nationality
                [formGroup]="host.qsaFormsControls[node.formIndex]"
                [nationality]="host.fieldsArray[node.formIndex].nationality"
                [rne]="host.fieldsArray[node.formIndex].rne"
                [rneEnabled]="host.fieldsArray[node.formIndex].rneEnabled"
                [nationalityList]="host.nationalityList"
              ></fd-nationality>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="!node.isLegalRepresentative">
          <ng-container *ngIf="host.isCollapsed(node, 'companyParticipation'); else companyParticipationEdit">
            <ng-container *ngTemplateOutlet="fieldText; context: { node: node, field: 'companyParticipation' }"></ng-container>
          </ng-container>
          <ng-template #companyParticipationEdit>
            <div class="qsa-field" (focusout)="host.confirmField(node, 'companyParticipation', $event)">
              <fd-currency-input
                [parentForm]="host.qsaFormsControls[node.formIndex]"
                [field]="host.fieldsArray[node.formIndex].companyParticipation"
              >
              </fd-currency-input>
            </div>
          </ng-template>
        </ng-container>

        <div class="qsa-field qsa-field--text qsa-field--pep" *ngIf="node.documentType === 'CPF'">
          <span class="qsa-field__label">
            Pessoa politicamente Exposta?
            <fa-icon
              class="qsa-field__info"
              icon="info-circle"
              matTooltipClass="fd-input__tooltip-dialog"
              [matTooltip]="host.PEP_TOOLTIP"
            ></fa-icon>
          </span>
          <div class="qsa-field__content">
            <mat-checkbox class="fd-checkbox" [formControl]="host.getPepControl(node)"> </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #fieldText let-node="node" let-field="field">
  <div class="qsa-field qsa-field--text">
    <span class="qsa-field__label">{{ host.getFieldLabel(field) }}</span>
    <div class="qsa-field__content">
      <button
        type="button"
        class="qsa-field__value qsa-field__value--editable"
        [attr.aria-label]="'Editar ' + host.getFieldLabel(field)"
        (click)="host.editField(node, field)"
      >
        {{ host.getFieldValue(node, field) }}
      </button>
    </div>
  </div>
</ng-template>
